import queryString from 'query-string';
import pickBy from 'lodash.pickby';
import dateFormat from 'date-fns/format';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import locale from 'date-fns/locale/sk';
import { t } from '../../app/i18n';
import { contractType, accountRoles, contractTypeT, installmentStatus } from '../../common/enums';
import * as moment from 'moment';

/**
 * Format numbers
 */
export const currencyFormatter = value =>
  `${Number(Number(value).toFixed(2)).toLocaleString('sk-SK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;

export const percentageFormatter = (value, minDigits) => {
  return `${(Number(value) * 100).toLocaleString('sk-SK', { minimumFractionDigits: minDigits ? minDigits : 1 })} %`;
}

/**
 * Format date
 */
export const formatDateTime = (date, format = 'D. MMM YYYY HH:mm') =>
  dateFormat(date, format, { locale });

export const formatDate = (date, format = 'D. MMM YYYY') => formatDateTime(date, format);

export const tranaslatedDistanceInWordsToNow = date => distanceInWordsToNow(date, { locale });

export function monthToString(month) {
  switch (month) {
    case 0:
      return t('Január');
    case 1:
      return t('Február');
    case 2:
      return t('Marec');
    case 3:
      return t('Apríl');
    case 4:
      return t('Máj');
    case 5:
      return t('Jún');
    case 6:
      return t('Júl');
    case 7:
      return t('August');
    case 8:
      return t('September');
    case 9:
      return t('Október');
    case 10:
      return t('November');
    case 11:
      return t('December');
    default:
      return '';
  }
}

export const formatMonthsCount = months => (months % 12 === 0 ? months / 12 : months);

export function formatMonthsQuantity(months) {
  const isYear = months % 12 === 0;
  const count = formatMonthsCount(months);

  if (count === 1) {
    return isYear ? t('rok') : t('mesiac');
  } else if (count > 1 && count < 5) {
    return isYear ? t('roky') : t('mesiace');
  }

  return isYear ? t('rokov') : t('mesiacov');
}

export const monthsFormatter = (months, withCount = false) => {
  let monthsT = '';

  if (months === 1) {
    monthsT = t('mesiac');
  } else if (months > 1 && months < 5) {
    monthsT = t('mesiace');
  } else {
    monthsT = t('mesiacov');
  }

  return withCount ? `${months} ${monthsT}` : monthsT;
};

/**
 * Others
 */
export const removeFalsyProperties = obj =>
  pickBy(obj, propValue => typeof propValue === 'boolean' || (typeof propValue === 'number' && !isNaN(propValue)) || propValue);

export const createQueryString = params =>
  queryString.stringify(removeFalsyProperties(params), {
    arrayFormat: 'index',
  });

export const convertJsonToQueryString = json => {
  if (!json) return '';
  
  return Object.entries(json).reduce( (query, [key, value]) => {
    return query.concat(
        Object.entries(value).reduce( (query2, [key2, value2]) => {
          return query2.concat(key.concat(`[${key2}]=${(value2 || value2 === 0 ? value2: '')}&`));
        }, ''));
  }, '' );
}

export const getFileUrl = (fileId, token) =>
  `${process.env.REACT_APP_API_URL}/file/${fileId}?token=${token}`;

// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript#answer-37511463
export const normalizeString = string =>
  string
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const getContractType = (type, accountRole) => {
  if (type === contractType.MANDATE) {
    return accountRole === accountRoles.DEBTOR
      ? contractTypeT.MANDATE_DEBTOR
      : contractTypeT.MANDATE_CREDITOR;
  }

  let str = contractTypeT[type];

  const maxLength = 90;
  if (str.length > maxLength) {
    str = str.slice(0, maxLength) + '...'
  }

  return str;
};


export const getDelayOfPayment = (installments, payments) => {
  let defineDay;

  if (installments.every(item => item.status === installmentStatus.PAID)) 
    return 0;
  
  const sortedPayments = payments.filter( p => p.transferredAt )
    .map( p => new Date(p.transferredAt) )
    .sort( (a,b) => b - a);

  const sortedInstallments = installments.filter( item => item.status === "UNPAID")
    .map( i => new Date(i.paymentDue) )
    .sort( (a,b) => a - b);

  if (sortedPayments.length > 0) {
    defineDay = sortedInstallments[0] > sortedPayments[0] ?  sortedInstallments[0] : sortedPayments[0];
  } else {
    defineDay = sortedInstallments[0];
  }
  
  //compare paymentDue of first installment vs. transferredAt of last payment and return the later(1.8. and 5.8. return 5.8.) 
  return moment().diff(moment(defineDay), 'days');
}

export const mapFilterToEndpointParams = filter => {
  return {
    transactionId: filter.transactionId,
    transactionType: filter.Type,
    accountFrom: filter.AccountFrom,
    accountTo: filter.AccountTo,
    amountFrom: (filter.Amount && filter.Amount.length > 0) ? filter.Amount[0] : null,
    amountTo: (filter.Amount && filter.Amount.length > 0) ? filter.Amount[1] : null,
    dateFrom: (filter.TransactionDateAt && filter.TransactionDateAt.length > 0) ? filter.TransactionDateAt[0] : null,
    dateTo: (filter.TransactionDateAt && filter.TransactionDateAt.length > 0) ? filter.TransactionDateAt[1] : null,
    loanNumber: filter.LoanNumber,
    investmentNumber: filter.InvestmentNumber,
    variableSymbol: filter.VS,
  }
}

export const mapToAllocationFilterEndpointParams = filter => {
  return {
    type: filter.type,
    status: filter.status,
    interest: filter.interest,
    months: filter.months,
    createdAt: (filter.createdAt.length > 0) ? [filter.createdAt[0].valueOf(), filter.createdAt[1].valueOf()] : filter.createdAt
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/helpers.js